<template>
  <span>
	  <span v-if="showNav">
      <a
        data-cy="side-administration-collapse"
        :aria-expanded="adminCollaps"
        class="sidebar-menu-item nav-link"
        data-toggle="collapse"
        @click="(adminCollaps=!adminCollaps)">
        <template>
            <i class="fa pr-2 fa-lock text-blue"></i>
            <span class="nav-link-text">Administration <b class="caret"></b></span>
        </template>
      </a>
      <collapse-transition :duration="{enter: 500, leave: 500}">
          <div v-show="adminCollaps" id="collapse-just" :class="adminCollaps?'show':''" class="collapse">
              <ul class="nav nav-sm flex-column">
                <slot v-for="(item, index) in links" name="title">
                      <router-link
                          :data-cy="getCypressDataCy(item.link)"
                          :key="index"
                          :target="item.link"
                          class="nav-link"
                          :href="item.link"
                          :to="item.link"
                          @click.native="linkClick"
                          :title="item.description"
                          b-v-tooltip.hover
                      >
                          <template>
                              <i :class="`${item.icon} pr-2`" :style="{color: item.icon_color}"></i>
                              <span class="nav-link-text">{{ item.name }}</span>
                          </template>
                      </router-link>
                  </slot>
                </ul>
              </div>
        </collapse-transition>
    </span>
</span>
</template>

<script>
import {CollapseTransition} from "vue2-transitions";

export default {
  name: 'side-admin-dynamic-group',
  components: {
    CollapseTransition,
  },
  data() {
		return {
			adminCollaps: false,
		};
  },
  computed: {
    links() {
      return this.$store.getters["getLinksByGroup"]('Administration')
    },
    showNav() {
      return this.$store.getters["getLinksByGroup"]('Administration').length > 0
    },
  },
  methods: {
    linkClick() {
      if (
          this.autoClose &&
          this.$sidebar &&
          this.$sidebar.showSidebar === true
      ) {
        this.$sidebar.displaySidebar(false);
      }
    },
    getCypressDataCy(route) {
      let formattedRoute = '';
      let arr = route.split('/');
      // console.log(arr)
      if (arr.length === 2) {
        formattedRoute = `${arr[arr.length - 1]}`;
      } else if (arr.length === 3) {
        formattedRoute = `${arr[arr.length - 2]}/${arr[arr.length - 1]}`;
        if (formattedRoute.includes(':')) {
          formattedRoute = `${arr[arr.length - 3]}/${arr[arr.length - 2]}`;
        }
      }
      // console.log(formattedRoute)
      return `side-administration-${formattedRoute}`;
    },
  }
}
</script>
